@if (enabled()) {
<div class="container" data-testid="shipping-banner">
  <h2 class="shipping-title" i18n="@@shipping-banner.title">Logistics</h2>
  <div class="ShippingBanner">
    <div class="ShippingBanner__item">
      <mat-icon aria-label="warehouse" fontSet="material-icons-outlined">warehouse</mat-icon>
      <h3 i18n="@@shipping-banner.pickup.title">Pickup</h3>
      <p i18n="@@shipping-banner.pickup.description" class="body-1">Pick it up from our location</p>
      @if (!!asset()?.branch_address && !!asset()?.branch_city && !!asset()?.branch_state && !!asset()?.branch_zipcode) {
        <app-link
          link-small
          link-secondary
          [href]="getLocationUrl()"
          target="_blank"
        >{{ asset()?.branch_address }}, {{ asset()?.branch_city }}, {{ asset()?.branch_state }} {{ asset()?.branch_zipcode }}</app-link>
      } @else {
        <span i18n="@@shipping-banner.pickup.not-available">Pickup not available</span>
      }
    </div>
    <div class="ShippingBanner__item">
      <mat-icon fontSet="material-icons-outlined">local_shipping</mat-icon>
      <h3 i18n="@@shipping-banner.shipping.title">Shipping</h3>
      <p i18n="@@shipping-banner.shipping.description" class="body-1">Ship to a location of your choice</p>
      <app-link
        link-small
        link-secondary
        href="https://www.veritread.com/exchange-contact/"
        target="_blank"
        i18n="@@shipping-banner.shipping.estimates"
      >Get shipping estimates</app-link>
    </div>
    <div class="ShippingBanner__divider">
      <div class="ShippingBanner__divider-line"></div>
      <div class="ShippingBanner__divider-text" i18n="@@shipping-banner.or">or</div>
      <div class="ShippingBanner__divider-line"></div>
    </div>
  </div>
</div>
}
